import React from 'react';
import { CapabilityBadge, CapabilityState } from './capabilityState';

// A horizontal shelf of a product's surfaced tools (spec: manifest.surfacedTools),
// each labeled with its real capability state. Never a bare list that implies
// every tool works -- every item is required to carry a state.
export interface ToolShelfItem {
  id: string;
  label: string;
  state: CapabilityState;
  note?: string;
}

export function OziraProductToolShelf({
  tools, onSelect,
}: {
  tools: ToolShelfItem[];
  onSelect?: (toolId: string) => void;
}) {
  if (!tools.length) return null;
  return (
    <div className="ozira-tool-shelf" role="group" aria-label="Tools">
      {tools.map((tool) => (
        <button
          key={tool.id}
          type="button"
          className="ozira-tool-shelf__item"
          disabled={tool.state === 'BLOCKED'}
          onClick={() => onSelect?.(tool.id)}
        >
          <span>{tool.label}</span>
          <CapabilityBadge state={tool.state} note={tool.note} />
        </button>
      ))}
    </div>
  );
}
